import http from "./http"

// let prefix = "";
let prefix = "/api";

const API = {
    letterCreditQuery: obj => http({url: prefix + "/letter/credit/query", method: "get", params: obj}),
    appVa: params => http({url: prefix + "/app/va/" + params, method: "get"}),

}

export default API
